(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var HomeTheaterFacade = function () {
  function HomeTheaterFacade(_ref) {
    var _ref$amplifier = _ref.amplifier;
    var amplifier = _ref$amplifier === undefined ? null : _ref$amplifier;
    var _ref$tuner = _ref.tuner;
    var tuner = _ref$tuner === undefined ? null : _ref$tuner;
    var _ref$dvdPlayer = _ref.dvdPlayer;
    var dvdPlayer = _ref$dvdPlayer === undefined ? null : _ref$dvdPlayer;
    var _ref$cdPlayer = _ref.cdPlayer;
    var cdPlayer = _ref$cdPlayer === undefined ? null : _ref$cdPlayer;
    var _ref$projector = _ref.projector;
    var projector = _ref$projector === undefined ? null : _ref$projector;
    var _ref$theaterLights = _ref.theaterLights;
    var theaterLights = _ref$theaterLights === undefined ? null : _ref$theaterLights;
    var _ref$screen = _ref.screen;
    var screen = _ref$screen === undefined ? null : _ref$screen;
    var _ref$popcornPopper = _ref.popcornPopper;
    var popcornPopper = _ref$popcornPopper === undefined ? null : _ref$popcornPopper;

    _classCallCheck(this, HomeTheaterFacade);

    this.amplifier = amplifier;
    this.tuner = tuner;
    this.dvdPlayer = dvdPlayer;
    this.cdPlayer = cdPlayer;
    this.projector = projector;
    this.theaterLights = theaterLights;
    this.screen = screen;
    this.popcornPopper = popcornPopper;
  }

  _createClass(HomeTheaterFacade, [{
    key: "watchMovie",
    value: function watchMovie(movie) {
      console.log('Get ready to watch a movie...');

      this.popcornPopper.on();
      this.popcornPopper.pop();

      this.theaterLights.off();

      this.screen.down();

      this.projector.on();
      this.projector.setWideScreenMode();

      this.amplifier.on();
      this.amplifier.setDvdPlayer(this.dvdPlayer);
      this.amplifier.setSurroundSound();
      this.amplifier.setVolume(5);

      this.dvdPlayer.on();
      this.dvdPlayer.play(movie);
    }
  }, {
    key: "endMovie",
    value: function endMovie() {
      console.log("Shutting movie theater down...");
      this.popcornPopper.off();

      this.theaterLights.on();

      this.screen.up();

      this.projector.off();

      this.amplifier.off();

      this.dvdPlayer.stop();
      this.dvdPlayer.eject();
      this.dvdPlayer.off();
    }
  }, {
    key: "listenToCd",
    value: function listenToCd(cd) {
      console.log("Start listening your music...");

      this.amplifier.on();
      this.amplifier.setCdPlayer(this.cdPlayer);
      this.amplifier.setStereoSound();
      this.amplifier.setVolume(5);

      this.cdPlayer.on();
      this.cdPlayer.play(cd);
    }
  }, {
    key: "endCd",
    value: function endCd() {
      console.log("End listening your music or the Cd has finished!");

      this.amplifier.off();

      this.cdPlayer.stop();
      this.cdPlayer.eject();
      this.cdPlayer.off();
    }
  }, {
    key: "listenToRadio",
    value: function listenToRadio() {
      console.log("Start listening your favorite radio station...");

      this.amplifier.on();
      this.amplifier.setTuner(this.tuner);
      this.amplifier.setStereoSound();
      this.amplifier.setVolume(5);

      this.tuner.on();
      this.tuner.setFm();
      this.tuner.setFrequency(90.9);
    }
  }, {
    key: "endRadio",
    value: function endRadio() {
      console.log("End listening your favorite radio station...");

      this.amplifier.off();

      this.tuner.off();
    }
  }]);

  return HomeTheaterFacade;
}();

exports.default = HomeTheaterFacade;

},{}],2:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Movie = function () {
  function Movie() {
    var name = arguments.length <= 0 || arguments[0] === undefined ? '' : arguments[0];
    var minutes = arguments.length <= 1 || arguments[1] === undefined ? 0 : arguments[1];
    var director = arguments.length <= 2 || arguments[2] === undefined ? '' : arguments[2];
    var actors = arguments.length <= 3 || arguments[3] === undefined ? [] : arguments[3];
    var description = arguments.length <= 4 || arguments[4] === undefined ? '' : arguments[4];

    _classCallCheck(this, Movie);

    this.name = name;
    this.minutes = minutes;
    this.director = director;
    this.actors = actors;
    this.description = description;
  }

  _createClass(Movie, [{
    key: 'setName',
    value: function setName(name) {
      this.name = name;
    }
  }, {
    key: 'setMinutes',
    value: function setMinutes(minutes) {
      this.minutes = minutes;
    }
  }, {
    key: 'setDirector',
    value: function setDirector(director) {
      this.director = director;
    }
  }, {
    key: 'setActors',
    value: function setActors(actors) {
      this.actors = actors;
    }
  }, {
    key: 'setDescription',
    value: function setDescription(description) {
      this.description = description;
    }
  }]);

  return Movie;
}();

exports.default = Movie;

},{}],3:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Movie2 = require('./Movie');

var _Movie3 = _interopRequireDefault(_Movie2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Nikita = function (_Movie) {
  _inherits(Nikita, _Movie);

  function Nikita() {
    _classCallCheck(this, Nikita);

    return _possibleConstructorReturn(this, Object.getPrototypeOf(Nikita).call(this, 'Nikita, hard to kill!', 120, 'Steven Spielberg', ['Brad Pitt'], 'Bloody!'));
  }

  return Nikita;
}(_Movie3.default);

exports.default = Nikita;

},{"./Movie":2}],4:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Switchable2 = require("./Switchable");

var _Switchable3 = _interopRequireDefault(_Switchable2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Amplifier = function (_Switchable) {
  _inherits(Amplifier, _Switchable);

  function Amplifier() {
    _classCallCheck(this, Amplifier);

    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(Amplifier).call(this));

    _this.volume = 0;
    _this.dvdPlayer = null;
    _this.cdPlayer = null;
    _this.tuner = null;
    _this.surroundSound = false;
    _this.stereoSound = false;
    return _this;
  }

  _createClass(Amplifier, [{
    key: "on",
    value: function on() {
      console.log("Amplifier is on!");
    }
  }, {
    key: "off",
    value: function off() {
      console.log("Amplifier is off!");
    }
  }, {
    key: "setVolume",
    value: function setVolume(volume) {
      this.volume = volume;
      console.log("Volume change to " + volume);
    }
  }, {
    key: "setDvdPlayer",
    value: function setDvdPlayer(dvdPlayer) {
      this.dvdPlayer = dvdPlayer;
      console.log("Plugged DVD Player to Amplifier!");
    }
  }, {
    key: "setCdPlayer",
    value: function setCdPlayer(cdPlayer) {
      this.cdPlayer = cdPlayer;
      console.log("Plugged Cd Player to Amplifier!");
    }
  }, {
    key: "setTuner",
    value: function setTuner(tuner) {
      this.tuner = tuner;
      console.log("Plugged on Tuner to Amplifier!");
    }
  }, {
    key: "setSurroundSound",
    value: function setSurroundSound() {
      this.surroundSound = true;
      console.log("Surround Mode is active!");
    }
  }, {
    key: "setStereoSound",
    value: function setStereoSound() {
      this.stereoSound = true;
      console.log("Stereo Mode is active!");
    }
  }]);

  return Amplifier;
}((0, _Switchable3.default)(null));

exports.default = Amplifier;

},{"./Switchable":11}],5:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Switchable2 = require('./Switchable');

var _Switchable3 = _interopRequireDefault(_Switchable2);

var _Playable = require('./Playable');

var _Playable2 = _interopRequireDefault(_Playable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CdPlayer = function (_Switchable) {
  _inherits(CdPlayer, _Switchable);

  function CdPlayer() {
    _classCallCheck(this, CdPlayer);

    return _possibleConstructorReturn(this, Object.getPrototypeOf(CdPlayer).apply(this, arguments));
  }

  _createClass(CdPlayer, [{
    key: 'on',
    value: function on() {
      console.log("CdPlayer is on!");
    }
  }, {
    key: 'off',
    value: function off() {
      console.log("CdPlayer is off!");
    }
  }, {
    key: 'eject',
    value: function eject() {
      console.log("Eject Cd!");
    }
  }, {
    key: 'play',
    value: function play(cd) {
      console.log("Playing " + cd.sName);
    }
  }, {
    key: 'stop',
    value: function stop() {
      console.log("Stop CdPlayer!");
    }
  }]);

  return CdPlayer;
}((0, _Switchable3.default)((0, _Playable2.default)(null)));

exports.default = CdPlayer;

},{"./Playable":7,"./Switchable":11}],6:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Switchable2 = require('./Switchable');

var _Switchable3 = _interopRequireDefault(_Switchable2);

var _Playable = require('./Playable');

var _Playable2 = _interopRequireDefault(_Playable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DvdPlayer = function (_Switchable) {
  _inherits(DvdPlayer, _Switchable);

  function DvdPlayer() {
    _classCallCheck(this, DvdPlayer);

    return _possibleConstructorReturn(this, Object.getPrototypeOf(DvdPlayer).apply(this, arguments));
  }

  _createClass(DvdPlayer, [{
    key: 'on',
    value: function on() {
      console.log("DvdPlayer is on!");
    }
  }, {
    key: 'off',
    value: function off() {
      console.log("DvdPlayer is off!");
    }
  }, {
    key: 'eject',
    value: function eject() {
      console.log("Eject Dvd!");
    }
  }, {
    key: 'play',
    value: function play(movie) {
      console.log("Playing " + movie.name);
    }
  }, {
    key: 'stop',
    value: function stop() {
      console.log("Stop DvdPlayer!");
    }
  }]);

  return DvdPlayer;
}((0, _Switchable3.default)((0, _Playable2.default)(null)));

exports.default = DvdPlayer;

},{"./Playable":7,"./Switchable":11}],7:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Playable = function Playable(Sup) {
  return function (_Sup) {
    _inherits(_class, _Sup);

    function _class() {
      _classCallCheck(this, _class);

      return _possibleConstructorReturn(this, Object.getPrototypeOf(_class).apply(this, arguments));
    }

    _createClass(_class, [{
      key: 'eject',
      value: function eject() {
        throw new Error('This method should be overwritten!');
      }
    }, {
      key: 'play',
      value: function play() {
        throw new Error('This method should be overwritten!');
      }
    }, {
      key: 'stop',
      value: function stop() {
        throw new Error('This method should be overwritten!');
      }
    }]);

    return _class;
  }(Sup);
};

exports.default = Playable;

},{}],8:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Switchable2 = require("./Switchable");

var _Switchable3 = _interopRequireDefault(_Switchable2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PopcornPopper = function (_Switchable) {
  _inherits(PopcornPopper, _Switchable);

  function PopcornPopper() {
    _classCallCheck(this, PopcornPopper);

    return _possibleConstructorReturn(this, Object.getPrototypeOf(PopcornPopper).apply(this, arguments));
  }

  _createClass(PopcornPopper, [{
    key: "on",
    value: function on() {
      console.log("PopcornPopper is on!");
    }
  }, {
    key: "off",
    value: function off() {
      console.log("PopcornPopper is off!");
    }
  }, {
    key: "pop",
    value: function pop() {
      console.log("Yum!Yum!");
    }
  }]);

  return PopcornPopper;
}((0, _Switchable3.default)(null));

exports.default = PopcornPopper;

},{"./Switchable":11}],9:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Switchable2 = require("./Switchable");

var _Switchable3 = _interopRequireDefault(_Switchable2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Projector = function (_Switchable) {
  _inherits(Projector, _Switchable);

  function Projector() {
    _classCallCheck(this, Projector);

    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(Projector).call(this));

    _this.wideScreenMode = false;
    return _this;
  }

  _createClass(Projector, [{
    key: "on",
    value: function on() {
      console.log("Projector is on!");
    }
  }, {
    key: "off",
    value: function off() {
      console.log("Projector is off!");
    }
  }, {
    key: "setWideScreenMode",
    value: function setWideScreenMode() {
      this.wideScreenMode = true;
      console.log("Projector now is on wide screen mode!");
    }
  }]);

  return Projector;
}((0, _Switchable3.default)(null));

exports.default = Projector;

},{"./Switchable":11}],10:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Screen = function () {
  function Screen() {
    _classCallCheck(this, Screen);
  }

  _createClass(Screen, [{
    key: "down",
    value: function down() {
      console.log("The screen is down!");
    }
  }, {
    key: "up",
    value: function up() {
      console.log("The screen is up!");
    }
  }]);

  return Screen;
}();

exports.default = Screen;

},{}],11:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Switchable = function Switchable(Sup) {
  return function (_Sup) {
    _inherits(_class, _Sup);

    function _class() {
      _classCallCheck(this, _class);

      return _possibleConstructorReturn(this, Object.getPrototypeOf(_class).apply(this, arguments));
    }

    _createClass(_class, [{
      key: 'on',
      value: function on() {
        throw new Error('This method should be overwritten!');
      }
    }, {
      key: 'off',
      value: function off() {
        throw new Error('This method should be overwritten!');
      }
    }]);

    return _class;
  }(Sup);
};

exports.default = Switchable;

},{}],12:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Switchable2 = require("./Switchable");

var _Switchable3 = _interopRequireDefault(_Switchable2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TheaterLights = function (_Switchable) {
  _inherits(TheaterLights, _Switchable);

  function TheaterLights() {
    _classCallCheck(this, TheaterLights);

    return _possibleConstructorReturn(this, Object.getPrototypeOf(TheaterLights).apply(this, arguments));
  }

  _createClass(TheaterLights, [{
    key: "on",
    value: function on() {
      console.log("The lights are on!");
    }
  }, {
    key: "off",
    value: function off() {
      console.log("The lights are off!");
    }
  }]);

  return TheaterLights;
}((0, _Switchable3.default)(null));

exports.default = TheaterLights;

},{"./Switchable":11}],13:[function(require,module,exports){
'use strict';

var _HomeTheaterFacade = require('./HomeTheaterFacade');

var _HomeTheaterFacade2 = _interopRequireDefault(_HomeTheaterFacade);

var _Amplifier = require('./elements/Amplifier');

var _Amplifier2 = _interopRequireDefault(_Amplifier);

var _DvdPlayer = require('./elements/DvdPlayer');

var _DvdPlayer2 = _interopRequireDefault(_DvdPlayer);

var _CdPlayer = require('./elements/CdPlayer');

var _CdPlayer2 = _interopRequireDefault(_CdPlayer);

var _Projector = require('./elements/Projector');

var _Projector2 = _interopRequireDefault(_Projector);

var _TheaterLights = require('./elements/TheaterLights');

var _TheaterLights2 = _interopRequireDefault(_TheaterLights);

var _Screen = require('./elements/Screen');

var _Screen2 = _interopRequireDefault(_Screen);

var _PopcornPopper = require('./elements/PopcornPopper');

var _PopcornPopper2 = _interopRequireDefault(_PopcornPopper);

var _Nikita = require('./Nikita');

var _Nikita2 = _interopRequireDefault(_Nikita);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var oHomeTheaterFacade = new _HomeTheaterFacade2.default({
  amplifier: new _Amplifier2.default(),
  dvdPlayer: new _DvdPlayer2.default(),
  cdPlayer: new _CdPlayer2.default(),
  projector: new _Projector2.default(),
  theaterLights: new _TheaterLights2.default(),
  screen: new _Screen2.default(),
  popcornPopper: new _PopcornPopper2.default()
});
oHomeTheaterFacade.watchMovie(new _Nikita2.default());
oHomeTheaterFacade.endMovie();

},{"./HomeTheaterFacade":1,"./Nikita":3,"./elements/Amplifier":4,"./elements/CdPlayer":5,"./elements/DvdPlayer":6,"./elements/PopcornPopper":8,"./elements/Projector":9,"./elements/Screen":10,"./elements/TheaterLights":12}]},{},[13])

